import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-download.tsx
/**
* icon.24.download
*
* Keywords: arrow, downward, save, tray, vertical, inbox, receiving, storage
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE3LjUgMTNhLjUuNSAwIDAgMSAuNS41djNhMS41IDEuNSAwIDAgMS0xLjUgMS41aC05QTEuNSAxLjUgMCAwIDEgNiAxNi41di0zYS41LjUgMCAwIDEgMSAwdjNhLjUuNSAwIDAgMCAuNS41aDlhLjUuNSAwIDAgMCAuNS0uNXYtM2EuNS41IDAgMCAxIC41LS41TTEyIDZhLjUuNSAwIDAgMSAuNS41djUuNzkzbDIuMTQ2LTIuMTQ2YS41LjUgMCAxIDEgLjcwNy43MDdsLTMgM2EuNS41IDAgMCAxLS43MDcgMGwtMy0zYS41LjUgMCAxIDEgLjcwOC0uNzA3bDIuMTQ2IDIuMTQ2VjYuNUEuNS41IDAgMCAxIDEyIDYiLz48L3N2Zz4=)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=13809-4466
*/
const Icon24Download = memo(function Icon24Download(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M17.5 13a.5.5 0 0 1 .5.5v3a1.5 1.5 0 0 1-1.5 1.5h-9A1.5 1.5 0 0 1 6 16.5v-3a.5.5 0 0 1 1 0v3a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 .5-.5M12 6a.5.5 0 0 1 .5.5v5.793l2.146-2.146a.5.5 0 1 1 .707.707l-3 3a.5.5 0 0 1-.707 0l-3-3a.5.5 0 1 1 .708-.707l2.146 2.146V6.5A.5.5 0 0 1 12 6"
		})
	});
});
//#endregion
export { Icon24Download };

//# sourceMappingURL=icon-24-download.js.map